export default __webpack_public_path__ + "static/VLE-CARS-1920x800-01-Slider-2-b6fc2a104e404a1b854500571efc4b6b.webp";